import axios from "axios";
import {get0xAddress} from "../../common/utils/function";

const api1 = axios.create();

api1.defaults.baseURL = process.env.NODE_ENV === "production" ? process.env.REACT_APP_SOCKET_URL : "https://harmony.blocksscan.io/api1";

function onError(response: any) {
  return { error: true, data: response.response.data };
}

function onSuccess(response: any) {
  if (response.data) {
    console.log(response.config.url, "Response ============", response.data);
    return response.data;
  } else {
    return response;
  }
}
export const blockService1 = {
  blocks: (query: any) => api1.get(`/blocks${query}`).then(onSuccess, onError),
};
export const addressService1 = {
  getAddress: (address: any) => api1.get(`/addresses/${get0xAddress(address)}`).then(onSuccess, onError),
};
export { api1 };
